import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
(function (w: any, d: Document) {
  if (w.fbq) return;
  var n: any = w.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!w._fbq) w._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  var s = d.createElement('script');
  s.async = true;
  s.src = 'https://connect.facebook.net/en_US/fbevents.js';
  d.head.appendChild(s);
  w.fbq('init', '1934048370513297');
  w.fbq('track', 'PageView');
})(window, document);
// noscript fallback image pixel
var img = document.createElement('img');
img.height = 1;
img.width = 1;
img.style.display = 'none';
img.src = 'https://www.facebook.com/tr?id=1934048370513297&ev=PageView&noscript=1';
document.body.appendChild(img);
// ============================================================
// React App
// ============================================================
render(<App data-id="element-434" />, document.getElementById('root'));